import createNativeActivityBridge from './nativeActivityBridge'

// Sync progress activity: Live Activity on iOS, foreground-service progress
// notification on Android, shown while sessions are synced. Exposes
// isAvailable, isSupported, start, update, stop.
export default createNativeActivityBridge('SyncActivity', { stopMethod: 'stop' })
